export default __webpack_public_path__ + "static/premio-ar-06ae35e534761eafe4332f7a16435b73.png";